export interface GroupsView {
    modelChanged(model: GroupsVM): void
}

export class GroupsVM {

}